import React, { useEffect, useState } from "react";
import {
  AddButton,
  CancelButton,
  SubmitButton,
  UpdateButton,
} from "../../../components/mui/Buttons/Buttons";
import { Form, FormikProvider, useFormik } from "formik";
import { Box, Stack, TextField } from "@mui/material";
import GlobalDialog from "../../../components/mui/Dialogue/GlobalDialog";
import GlobalSelectField from "../../../components/mui/GlobalSelectField";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import {
  addBrand,
  addVendor,
  getAllBrands,
  getAllBrandsList,
  getAllVendors,
} from "../../../redux/features/assetManagementSlice";
import { reset } from "numeral";

const Addvendor = ({ dispatchParams }) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading } = useSelector((state) => state.assetmanagement);

  const ValidationSchema = Yup.object().shape({
    name: Yup.string().required("Please add vendor name"),
    phoneNumber: Yup.string().required("Add phone number"),
    email: Yup.string().required("Add email id"),
    address: Yup.string().required("Add address"),
    place: Yup.string().required("Add place"),
    gst: Yup.string().required("Add GST number"),
  });

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      name: "",
      phoneNumber: "",
      email: "",
      address: "",
      place: "",
      gst: "",
    },
    validationSchema: ValidationSchema,
    onSubmit: (values, { resetForm }) => {
      dispatch(addVendor({ data: [values] })).then((res) => {
        console.log(res);
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, {
            variant: "success",
          });
          dispatch(getAllVendors(dispatchParams));
          formik.resetForm();
          setOpen(false);
        } else {
          enqueueSnackbar(res.payload.message, {
            variant: "error",
          });
          // setOpen(false);
        }
      });
    },
  });

  return (
    <GlobalDialog
      title={"Add Vendor"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"sm"}
      closeButton={true}
      popupButton={
        <AddButton size="medium" action={() => setOpen(true)}>
          Add Vendor
        </AddButton>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={"column"} spacing={2}>
                  <TextField
                    name="name"
                    value={formik.values.name}
                    error={formik.touched.name && Boolean(formik.errors.name)}
                    helperText={formik.errors.name}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Vendor Name"
                  />
                  <TextField
                    name="phoneNumber"
                    value={formik.values.phoneNumber}
                    error={
                      formik.touched.phoneNumber &&
                      Boolean(formik.errors.phoneNumber)
                    }
                    helperText={formik.errors.phoneNumber}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Phone Number"
                  />
                  <TextField
                    name="email"
                    value={formik.values.email}
                    error={formik.touched.email && Boolean(formik.errors.email)}
                    helperText={formik.errors.email}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Email ID"
                  />
                  <TextField
                    name="address"
                    value={formik.values.address}
                    error={
                      formik.touched.address && Boolean(formik.errors.address)
                    }
                    helperText={formik.errors.address}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Address"
                  />
                  <TextField
                    name="place"
                    value={formik.values.place}
                    error={formik.touched.place && Boolean(formik.errors.place)}
                    helperText={formik.errors.place}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Place"
                  />
                  <TextField
                    name="gst"
                    value={formik.values.gst}
                    error={formik.touched.gst && Boolean(formik.errors.gst)}
                    helperText={formik.errors.gst}
                    onChange={formik.handleChange}
                    fullWidth
                    label="GST Number"
                  />
                </Stack>
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}
                >
                  <Stack direction={"row"} spacing={1}>
                    <CancelButton size="small" action={() => setOpen(false)}>
                      Cancel
                    </CancelButton>
                    <SubmitButton disabled={loading} size="small" type="submit">
                      {loading ? "Please wait..." : "Save"}
                    </SubmitButton>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default Addvendor;
